import "./insightSwitcher.css";
import blog from "../../assets/blog.png";
import blogActive from "../../assets/blogactive.png";
import factsheet from "../../assets/factsheet.png";
import factsheetActive from "../../assets/factsheetactive.png";
import news from "../../assets/news.png";
import newsActive from "../../assets/newsactive.png";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const InsightSwitcher = () => {
  const [active, setActive] = useState({
    blog: true,
    factsheet: false,
    news: false,
  });

  const { type } = useParams();
  useEffect(() => {
    if (type === "blog") {
      setActive({ blog: true, factsheet: false, news: false });
    } else if (type === "factsheet") {
      setActive({ blog: false, factsheet: true, news: false });
    } else if (type === "news") {
      setActive({ blog: false, factsheet: false, news: true });
    }
  }, [type]);

  const navigat = useNavigate();

  return (
    <div className="main-switcher-cnt">
      <div className="ins-head-cnt">
        <p className="ins-head">Insights</p>
        <p className="ins-subhead">
          Explore Insights Hub: Your Gateway to Resources for Elevated Success
        </p>
      </div>
      <div className="switcher-cnt">
        <div
          className="switcher-cnt-img"
          onClick={() => navigat(`/insights/blog`)}
        >
          <img src={active.blog ? blogActive : blog} alt="" />
          <span className={`${active.blog ? "text-blue" : undefined}`}>
            Blogs
          </span>
        </div>
        <div
          className="switcher-cnt-img"
          onClick={() => navigat(`/insights/factsheet`)}
        >
          <img src={active.factsheet ? factsheetActive : factsheet} alt="" />
          <span className={`${active.factsheet ? "text-blue" : undefined}`}>
            Fact Sheets
          </span>
        </div>
        <div
          className="switcher-cnt-img"
          onClick={() => navigat(`/insights/news`)}
        >
          <img src={active.news ? newsActive : news} alt="" />
          <span className={`${active.news ? "text-blue" : undefined}`}>
            News
          </span>
        </div>
      </div>
    </div>
  );
};

export default InsightSwitcher;
